export const facebookStatisticsFilters = [
  {
    label: 'Общие',
    options: [
      {value: 'state', label: 'Состояние'},
      {value: 'traffic_type', label: 'Типы трафика'},
    ],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'traffic_id', label: 'Кампания'},
      {value: 'link_id', label: 'Поток'},
      {value: 'pixel_id', label: 'Пиксель'},
      {value: 'bayer_id', label: 'Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'brand_id', label: 'Бренд'},
      {value: 'country_id', label: 'ГЕО'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'landing_id', label: 'Лендинг'},
    ],
  },
  {
    label: 'Приложения',
    options: [
      {value: 'app_id', label: 'Приложение'},
      {value: 'app_service_id', label: 'Сервисы', isSearch: false},
      {value: 'app_type', label: 'Платформа'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot_id', label: 'Бот'},
      {value: 'channel_id', label: 'Канал'},
      {value: 'tg_account_id', label: 'Телеграм Аккаунт'},
      {value: 'channel_group_id', label: 'Группа Каналов'},
    ],
  },
];
